import { supabase } from './supabase';

export const SERVICE_ORDER_STATUSES = [
  { value: 'aberta', label: 'Aberta' },
  { value: 'diagnostico', label: 'Diagnóstico' },
  { value: 'aguardando_aprovacao', label: 'Aguardando aprovação' },
  { value: 'em_execucao', label: 'Em execução' },
  { value: 'aguardando_peca', label: 'Aguardando peça' },
  { value: 'finalizada', label: 'Finalizada' },
  { value: 'entregue', label: 'Entregue' },
  { value: 'atrasada', label: 'Atrasada' },
  { value: 'cancelada', label: 'Cancelada' },
];

export const SERVICE_ORDER_STATUS_TRANSITIONS = {
  aberta: ['diagnostico', 'aguardando_aprovacao', 'em_execucao', 'cancelada'],
  diagnostico: ['aguardando_aprovacao', 'em_execucao', 'aguardando_peca', 'cancelada'],
  aguardando_aprovacao: ['em_execucao', 'aguardando_peca', 'cancelada'],
  em_execucao: ['aguardando_peca', 'finalizada', 'cancelada'],
  aguardando_peca: ['em_execucao', 'finalizada', 'cancelada'],
  finalizada: ['entregue'],
  entregue: [],
  atrasada: ['em_execucao', 'aguardando_peca', 'finalizada', 'cancelada'],
  cancelada: [],
};

export function canTransitionStatus(fromStatus, toStatus) {
  const allowedTransitions = SERVICE_ORDER_STATUS_TRANSITIONS[fromStatus] || [];
  return allowedTransitions.includes(toStatus);
}

export function serviceOrderStatusLabel(value) {
  return SERVICE_ORDER_STATUSES.find((status) => status.value === value)?.label
    || String(value || 'Sem status').replaceAll('_', ' ');
}

export async function createServiceOrder(payload) {
  const { data, error } = await supabase.rpc('create_service_order', { payload });
  if (error) throw error;
  return data;
}

export async function deleteServiceOrder(orderId) {
  const { error } = await supabase.rpc('delete_service_order', {
    target_order_id: orderId,
  });
  if (error) throw error;
}
